import {gsap} from "gsap";
import {VNode} from "vue";

enum DragState {
    None,
    ItemSelected,
    Dragging,
}

let dragState = {
    state: DragState.None,
    initialMousePosition: {
        x: 0,
        y: 0
    },
    element: <HTMLElement|null> null,
    data: null
};

function distance(x1: number, y1: number, x2: number, y2: number) {
    let a = x1 - x2;
    let b = y1 - y2;
    return Math.sqrt( a*a + b*b );
}

function mouseDistance(e: MouseEvent): number {
    return distance(dragState.initialMousePosition.x, dragState.initialMousePosition.y, e.x, e.y);
}

const dragThreshold = 10;
let hasInit = false;

function init() {
    if (hasInit)
        return;

    hasInit = true;

    document.body.addEventListener("mousemove", (e) => {
        if (dragState.state === DragState.None)
            return;

        if (dragState.state === DragState.ItemSelected) {
            if (mouseDistance(e) > dragThreshold) {
                dragState.state = DragState.Dragging;
            }
        }

        if (dragState.state === DragState.Dragging) {
            gsap.set(dragState.element, {
                x: e.x - dragState.initialMousePosition.x,
                y: e.y - dragState.initialMousePosition.y
            });
            if (dragState.element)
                dragState.element.style.pointerEvents = "none";
        }
    });

    document.body.addEventListener("mouseup", (e) => {
        if (dragState.state === DragState.Dragging) {
            gsap.to(dragState.element, {
                x: 0,
                y: 0,
                animationDuration: 0
            });
            if (dragState.element)
                dragState.element.style.pointerEvents = "all";
        }

        dragState.state = DragState.None;
    });
}

export let draggable = {
    bind(el: HTMLElement, binding: any, vnode: VNode) {
        init();
        setListener(el, binding);
    },
    update(el: any, binding: any, vnode: VNode) {
        el.removeEventListener("mousedown", el.startDragEvent);
        setListener(el, binding);
    },
    unbind(el: any) {
        el.removeEventListener("mousedown", el.startDragEvent);
    }
};

function setListener(el: any, binding: any) {
    el.startDragEvent = (event: MouseEvent) => {
        if (el.getAttribute("disabled") === "disabled" ||
            el.getAttribute("aria-disabled") === "true")
            return;

        dragState.element = el;
        dragState.state = DragState.ItemSelected;
        dragState.initialMousePosition.x = event.x;
        dragState.initialMousePosition.y = event.y;
        dragState.data = binding.value;
    };

    el.addEventListener("mousedown", el.startDragEvent);
}

export let dropTarget = {
    bind(el: any, binding: any, vnode: VNode) {
        el.drop = (event: MouseEvent) => {
            if (dragState.state === DragState.Dragging) {
                let f = vnode.data?.on?.drop;
                if (f) {
                    if (Array.isArray(f)) {
                        for (let func of f) {
                            func(dragState.data);
                        }
                    }
                    else {
                        f(dragState.data);
                    }

                }
            }
        };

        el.addEventListener("mouseup", (e: MouseEvent) => el.drop(e));
    },
    unbind(el: any) {
        el.removeEventListener("mouseup", el.startDragEvent);
    }
};